import { Component, OnInit, Input } from '@angular/core';
import { tracking_status_model } from './tracking-item-status.model';

@Component({
  selector: 'kett-tracking-item-status',
  templateUrl: './tracking-item-status.component.html',
  styleUrls: ['./tracking-item-status.component.scss'],
})
export class TrackingItemStatusComponent implements OnInit {
  @Input() icon_code: string;
  @Input() description: string;
  @Input() img_width: string = '100px';

  constructor() {}
  ngOnInit(): void {}
}
